//------------------//
// GSAP
//------------------//
// import { gsap } from 'gsap';
// import { ScrollTrigger } from 'gsap/ScrollTrigger';
// import { ScrollSmoother } from 'gsap/ScrollSmoother';
// import { SplitText } from 'gsap/SplitText';

// // Scroll Smoother & Split Text from GSAP
// gsap.registerPlugin(ScrollTrigger, ScrollSmoother, SplitText);

// let smoother = ScrollSmoother.create({
//     wrapper: '#smooth-wrapper',
//     content: '#smooth-content',
// });

// function titleAnimations() {
//     const titles = gsap.utils.toArray('.animated-title');

//     titles.forEach((title) => {
//         let splitTitle = new SplitText(title, { type: 'lines, chars', linesClass: 'split-lines' });
//         let chars = splitTitle.chars;

//         gsap.from(chars, {
//             opacity: 0,
//             y: 10,
//             ease: 'expo',
//             stagger: 0.02,
//             duration: 1.5,
//             scrollTrigger: {
//                 trigger: title,
//                 // markers: true,
//                 id: 'Animated Titles',
//                 start: 'top bottom-=100px',
//                 end: 'top bottom-=100px',
//             }
//         });
//     });
// }

// titleAnimations();





//------------------//
// Alpine.js
//------------------//
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
// import focus from '@alpinejs/focus';
global.Alpine = Alpine;

Alpine.plugin(collapse);
// Alpine.plugin(focus);
Alpine.start();





//------------------//
// Lazy load images
//------------------//
import Lazyload from 'vanilla-lazyload';
global.Lazyload = Lazyload;

// Create Lazy load instance
var lazyLoadInstance = new Lazyload({
    elements_selector: '.lazy'
    // ... more custom settings?
});
global.lazyLoadInstance = lazyLoadInstance;





//------------------//
// Flickity
//------------------//
const Flickity = require('flickity');
// require('flickity-imagesloaded');
// require('flickity-fade');
global.Flickity = Flickity;





//------------------//
// Fancybox
//------------------//
import { Fancybox } from "@fancyapps/ui";
